<template>
<div
    class="form-submission-card-signature"
    v-if="signature"
    @click="$emit('open-signature')"
>
    <img
        :src="'/svg/' + resource_group + '/signature.svg'"
        :alt="`${signature.user ? signature.user.full_name + '\'s signature' : 'signature'}`"
        width="35px"
        height="auto"
    />
</div>
</template>

<script>
export default {
    props: [
        'signature',
    ],
    emits: ['open-signature'],
}
</script>
